/*
  HomeRequest.js - HomeRequest Networking File

  Contains networking functionality for Home Component
*/

// MODULES
import RequestRabbit from './RequestRabbit';

// CONFIGURATION
import config from '../Config';

const useHomeRequest = () => {
  // Function to fetch Customer and CustomerUser data
  const getUser = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/users/user`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      if (!response) return null;

      return await response?.json();
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  // Function to fetch session data
  const getSessionData = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/session/data`;
      const options = {
        method: 'GET',
      };

      const response = await RequestRabbit.request(url, options, errorHandler);
      if (!response) return null;

      return await response?.json();
    } catch (e) {
      errorHandler(e.message);
      return null;
    }
  };

  // Export functions as a module
  return {
    getUser,
    getSessionData,
  };
};
export default useHomeRequest;
